<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
    <el-table-column prop="operationName" label="运营商" align="center"></el-table-column>
    <el-table-column prop="status" label="状态" align="center">
      <template slot-scope="{row}">
        <span v-if="row.status == '1'">绑定</span>
        <span v-else>解绑</span>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" label="更新时间" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { wxUserBindCardRecordList } from "@/api/api.js";
export default {
  props: {
    userId: {
      type: [String]
    }
  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  methods: {
    // 状态转换
    inventoryStatusType(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        userId:this.userId
      };
      wxUserBindCardRecordList(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index) =>{
            item.ids = index + 1;
            item.cardStatus = this.inventoryStatusType(item.cardStatus);
            item.showStatus = this.inventoryStatusType(item.showStatus);
          })
        }
      })
    },
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>


